import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { WarningCircleIcon } from '@yonderland/andes-icons';
import { Box, Icon, StackBlock, StackInline, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
export const PreviewWithValidationError = ({ isValid, children }) => {
    const { t } = useTranslation(I18N_NAMESPACES.checkout);
    return (_jsxs(StackBlock, { gap: "1", children: [children, !isValid && (_jsxs(StackInline, { gap: "1", wrap: "nowrap", children: [_jsx(Box, { paddingBlockStart: "1", children: _jsx(Icon, { source: WarningCircleIcon, color: "error", size: "xs" }) }), _jsx(TextAlpha, { color: "error", children: t('checkout.delivery.validation.error') })] }))] }));
};
